var _rect, _rect2, _path, _circle, _circle2, _circle3, _circle4, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpen3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 39,
    width: 57,
    height: 74.8125,
    rx: 3.5625,
    fill: "#499E8D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56.3125,
    y: 49.6875,
    width: 40.375,
    height: 53.4375,
    rx: 3.5625,
    fill: "#CEE6E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 93H83.975H88L83.975 84.4064V79.2505V74.6672H86.275L83.975 72.3756V66.0735C77.535 55.0738 71.325 61.4903 69.025 66.0735V84.4064L65 93Z",
    fill: "#3ECAB6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 72.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 72.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 64.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 64.5,
    r: 1.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79 57.9993C73.8333 55.166 63.5 53.1993 63.5 67.9993C63.5 86.4993 65 86.5 59.5 85.5",
    stroke: "#49A898",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8184 93.9654C89.509 93.286 90.6655 93.8873 90.5061 94.8428L90.4046 95.4514C90.3333 95.8787 90.5453 96.3033 90.9297 96.5031L91.4771 96.7878C92.3366 97.2346 92.1221 98.5203 91.1641 98.6639L90.554 98.7555C90.1255 98.8197 89.7872 99.1526 89.7159 99.5799L89.6144 100.188C89.455 101.144 88.166 101.337 87.7333 100.471L87.4578 99.9186C87.2642 99.531 86.8432 99.312 86.4147 99.3763L85.8046 99.4678C84.8465 99.6115 84.2644 98.4453 84.9549 97.766L85.3948 97.3333C85.7036 97.0295 85.7817 96.5614 85.5882 96.1738L85.3126 95.6217C84.8799 94.755 85.8091 93.841 86.6686 94.2878L87.216 94.5724C87.6004 94.7723 88.0698 94.7019 88.3786 94.3981L88.8184 93.9654Z",
    fill: "#64F6EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8803 87.5309C68.78 86.5674 69.9712 86.0384 70.6187 86.7589L71.0311 87.2179C71.3207 87.5401 71.7848 87.6392 72.1808 87.4634L72.7447 87.213C73.63 86.8198 74.5012 87.7893 74.0161 88.6278L73.707 89.1618C73.4901 89.5368 73.5392 90.0088 73.8288 90.3311L74.2412 90.79C74.8887 91.5105 74.2359 92.6387 73.2885 92.4363L72.6851 92.3075C72.2615 92.217 71.8277 92.4096 71.6107 92.7846L71.3017 93.3186C70.8165 94.157 69.5419 93.8848 69.4416 92.9213L69.3777 92.3076C69.3328 91.8767 69.0156 91.5237 68.5919 91.4332L67.9885 91.3044C67.0412 91.102 66.9062 89.8056 67.7915 89.4125L68.3554 89.1621C68.7514 88.9863 68.9891 88.5755 68.9442 88.1446L68.8803 87.5309Z",
    fill: "#64F6EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen3);
export default __webpack_public_path__ + "static/media/open 3.ebfb1d3b96f1d223a738b8948d7863e7.svg";
export { ForwardRef as ReactComponent };